import { NextRouteComponent } from '@pankod/refine-nextjs-router'
import { GetServerSideProps } from 'next'

export const getServerSideProps: GetServerSideProps = async () => {
  return { props: {} }
}

export default NextRouteComponent
